import React, { useState } from "react";
import Layout from "pages/HomePage/Layout";
import "./WelcomePage.css";
import LogoImg from "../../assets/images/mark.png";
import { Col, Row } from "antd";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const WelcomePage = () => {
  // Use the registration info from Redux store (set during checkout)
  // This preserves the correct registration that the user just registered for
  const appDataStore = useSelector((x) => x.appDataStore);
  const [resStatus, setRecStatus] = useState(true);
  const [appName, setAppName] = useState("");

  useEffect(() => {
    // Get registration info from Redux store (already set by RegisterPage)
    const registrationInfo = appDataStore?.appInfo?.registration_info;
    if (registrationInfo) {
      setAppName(registrationInfo.registration_name || "");
      setRecStatus(registrationInfo.status === "1");
      return;
    }
    try {
      const stored = localStorage.getItem("welcome_context");
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed?.registration_name) {
          setAppName(parsed.registration_name);
        }
      }
    } catch {}
  }, [appDataStore]);

  const regTypeValue = (
    appDataStore?.appInfo?.registration_info?.registration_type ||
    (() => {
      try {
        const stored = localStorage.getItem("welcome_context");
        return stored ? JSON.parse(stored)?.registration_type : "";
      } catch {
        return "";
      }
    })()
  )
    .toString()
    .trim()
    .toLowerCase();
  const isFacilityType = regTypeValue === "facility";
  const registrationTotalRaw =
    appDataStore?.registrationResult?.total_checkout ??
    (() => {
      try {
        const stored = localStorage.getItem("welcome_context");
        return stored ? JSON.parse(stored)?.total_checkout : undefined;
      } catch {
        return undefined;
      }
    })();
  const registrationTotal =
    registrationTotalRaw !== undefined && registrationTotalRaw !== null
      ? parseFloat(registrationTotalRaw)
      : null;
  const isZeroPayment = !isFacilityType && registrationTotal === 0;

  const paymentMethod =
    appDataStore?.registrationResult?.payment_method ||
    (() => {
      try {
        const stored = localStorage.getItem("welcome_context");
        return stored ? JSON.parse(stored)?.payment_method : "";
      } catch {
        return "";
      }
    })();

  const payStatus =
    appDataStore?.registrationResult?.pay_status ??
    (() => {
      try {
        const stored = localStorage.getItem("welcome_context");
        return stored ? JSON.parse(stored)?.pay_status : undefined;
      } catch {
        return undefined;
      }
    })();

  const isManualInvoiceFlow =
    !isFacilityType && (paymentMethod === "manual" || String(payStatus) === "0");

  return (
    <Layout resStatus={resStatus}>
      <div className="welcome">
        <Row
          style={{ marginTop: 50 }}
          gutter={[32, 16]}
          align={"middle"}
          justify={"center"}
        >
          {/* <Col>
            <Link to="/">
              <img
                src={LogoImg}
                style={{ width: "150px", height: "auto", cursor: "pointer" }}
              />
            </Link>
          </Col> */}
          <Col style={{ textAlign: "center" }}>
            <p className="slide-title" style={{ marginBottom: 0 }}>
              {appName}
            </p>
          </Col>
        </Row>
        <div className="welcome-title">
          {isFacilityType
            ? "Application Submitted Successfully"
            : isManualInvoiceFlow
              ? "An Invoice has been emailed"
              : isZeroPayment
              ? "Registration Successful"
              : "Payment Successful"}
        </div>
        <div className="welcome-subtitle" style={{ marginTop: 50 }}>
          {isFacilityType
            ? `Your application for ${appName} has been received.`
            : `Thank you for Registering for ${appName}`}
        </div>
        <div className="welcome-subtitle">
          {isFacilityType
            ? "A copy of your application will be emailed to you"
            : isManualInvoiceFlow
              ? "Your registration is currently unpaid. Please follow the invoice instructions to complete payment"
            : isZeroPayment
              ? "A confirmation will be emailed to you"
              : "A receipt will be emailed to you"}
        </div>
      </div>
    </Layout>
  );
};

export default WelcomePage;
